import { Box, MenuItem } from "@material-ui/core";
import React from "react";
import PinIcon from "@material-ui/icons/Room";
import AutocompleteFormatter from "./AutocompleteFormatter";

export default function RenderSuggestion(suggestionProps, vehicleAutocomplete) {
  const {
    suggestion,
    index,
    itemProps,
    highlightedIndex,
    selectedItem,
    value,
    iconHidden
  } = suggestionProps;
  const isHighlighted = highlightedIndex === index;
  const isSelected =
    (selectedItem ? selectedItem.description : "").indexOf(suggestion.label) >
    -1;

  return (
    <MenuItem
      {...itemProps}
      key={index}
      selected={isHighlighted}
      component="div"
      data-cy="autocompleteSuggestion"
      style={{
        fontWeight: isSelected ? 500 : 400,
        minHeight: 40,
        backgroundColor: isHighlighted ? "#EEE" : "#FFF"
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        style={{
          overflow: "hidden"
        }}
        px={vehicleAutocomplete ? 0 : 0.5}
      >
        {!iconHidden && (
          <Box
            display="flex"
            justifyContent="center"
            style={{ minWidth: 44 }}
            mr={1}
          >
            <PinIcon style={{ color: "#c4c4c4", width: "24px" }} />{" "}
          </Box>
        )}

        <span
          style={{
            textOverflow: "ellipsis",
            overflow: "hidden"
          }}
        >
          {value && (
            <AutocompleteFormatter
              query={value}
              string={suggestion.description}
            />
          )}
        </span>
      </Box>
    </MenuItem>
  );
}
